import React from 'react';
import { InputBoolean } from '../InputBoolean';
import { TextPrivacy, RadioButtonWrapper, RadioButtonsContainer } from './style';

export const PrivacyBlock = ({
    onChange,
    isAccepted
}) => {
    return (
        <React.Fragment>
            <TextPrivacy>I tuoi dati saranno trattati da Vivigas Spa, con sede legale in Roncadelle (BS), Via Vittorio Emanuele II n. 4/28 in qualità di titolare del trattamento, in conformità a quanto previsto dalle vigenti normative in tema di trattamento dati  e come da nostra <a target='_blank' rel="noopener noreferrer" href="https://www.vivigas.it/normativa/informativa-privacy">Informativa privacy</a>, i Tuoi dati saranno salvati per poter proseguire con la sottoscrizione online e/o per poter essere ricontattato da VIVIgas nel caso il processo venga interrotto</TextPrivacy>
            <RadioButtonsContainer>
                <RadioButtonWrapper>
                    <InputBoolean
                        onChange={_ => onChange(true)}
                        label="PRESTO IL CONSENSO"
                        type="radio"
                        name="privacy"
                        isChecked={isAccepted}
                    />
                </RadioButtonWrapper>

                <RadioButtonWrapper>
                    <InputBoolean
                        type="radio"
                        onChange={_ => onChange(false)}
                        label="NEGO IL CONSENSO"
                        name="privacy"
                        isChecked={!isAccepted}
                    />
                </RadioButtonWrapper>
            </RadioButtonsContainer>
        </React.Fragment>
    )
}